if (!window.Eurus.loadedScript.has('quantity-selector.js')) {
  window.Eurus.loadedScript.add('quantity-selector.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xQuantitySelector', (
        productId,
        sectionId,
        qtyRuleMin,
        qtyRuleMax,
        isQtyRule,
        currencyCodeEnable,
        moneyWithCurrency,
        moneyFormat,
        quantityPriceBreaks = [],
        cartQtyVariant = 0,
        isTrackedInventory = false,
        inventoryQuantity = 0,
        disableAtc = false
      ) => ({
        qty: qtyRuleMin,
        min: qtyRuleMin,
        max: qtyRuleMax,
        inventoryQuantity: inventoryQuantity,
        errInventory: false,
        errIncrement: false,
        errMax: false,
        atcDisabledBySelector: false,
        initQtyChangeEvent(selector) {
          this.$nextTick(() => { 
            this.qty = document.getElementById(selector)?.value;
            document.addEventListener(`eurus:product:quantity-changed-${sectionId}`, (e) => {
              this.qty = e.detail.quantity;
            })
          });
        },
        minus(value) {
          if (this.qty - value <= this.min) {
            this.qty = this.min;
          } else {
            this.qty = parseInt(this.qty);
            (this.qty == 1) ? this.qty = 1 : this.qty = Math.ceil((this.qty - value) / value) * value;
          }
          this.errIncrement = false;
          this.errMax = false;
          this.errInventory = false;
          this.updatePrice();
        },
        plus(value) {
          const step = value > 0 ? value : 1;
          if(Number(this.qty) + value >= (this.max - cartQtyVariant) && isQtyRule) {
            this.qty = parseInt(this.max - cartQtyVariant);
          } else if (Number(this.qty) + step >= (this.inventoryQuantity - cartQtyVariant) && isTrackedInventory) {
            this.qty = parseInt(Math.floor((this.inventoryQuantity - cartQtyVariant) / step) * step);
          } else {
            this.qty = parseInt(this.qty);
            this.qty = this.qty - this.qty % value + value;
          }
          this.errIncrement = false;
          this.errMax = false;
          this.errInventory = false;
          this.updatePrice();
        },
        invalid(el, qtyRuleIncrement) {
          const number = parseFloat(el.value);
          this.errIncrement = false;
          this.errMax = false;
          this.errInventory = false;
          if (!Number.isInteger(number) || number < 1) {
            this.qty = this.min;
            this.updatePrice();
          }
          if (this.max != null && number > (this.max - cartQtyVariant)) {
            this.errMax = true;
          } else if (number > (this.inventoryQuantity - cartQtyVariant) && isTrackedInventory) {
            this.errInventory = true;
          } else if (number % qtyRuleIncrement != 0) {
            this.errIncrement = true; 
          } else {
            this.updatePrice();
          }
          this.setStatusAtc();
        },
        updatePrice() {
          const productTemplate = document.getElementById(`x-product-template-${productId}-${sectionId}`);
          const moneyFormatType = currencyCodeEnable ? moneyWithCurrency : moneyFormat;
          const update = (selector, value) => {
            const el = productTemplate.querySelector(selector);
            if (el) el.innerHTML = value;
          };
          if (quantityPriceBreaks.length <= 0) {
            const getPrice = (selector) => {
              return Number(productTemplate.querySelector(selector).innerHTML) * this.qty;
            };
 
            let productPrice = Alpine.store('xHelper').formatMoney(getPrice('.target-price'), moneyFormatType);
            let productCompareAtPrice = Alpine.store('xHelper').formatMoney(getPrice('.target-compare-at-price'), moneyFormatType);

            update('.add_to_cart_button .main-product-price .price', productPrice);
            update('.add_to_cart_button .main-product-price .price-sale', productPrice);
            update('.add_to_cart_button .main-product-price .price-compare', productCompareAtPrice);
          } else {
            let currentPrice = Number(productTemplate.querySelector('.target-price').innerHTML);
            const compareAtPrice = Number(productTemplate.querySelector('.target-compare-at-price').innerHTML);
            for(let i = 0; i < quantityPriceBreaks.length; i++) {
              if((Number(this.qty) + cartQtyVariant) >= quantityPriceBreaks[i].minimum_quantity) {
                currentPrice = quantityPriceBreaks[i].price;
              }
            }
            update('.add_to_cart_button .main-product-price .price', Alpine.store('xHelper').formatMoney(currentPrice * this.qty, moneyFormatType));
            update('.add_to_cart_button .main-product-price .price-sale', Alpine.store('xHelper').formatMoney(currentPrice * this.qty, moneyFormatType));
            update('.add_to_cart_button .main-product-price .price-compare', Alpine.store('xHelper').formatMoney(compareAtPrice * this.qty, moneyFormatType));
            update('.add_to_cart_button .main-product-price .unit-price', Alpine.store('xHelper').formatMoney(currentPrice, moneyFormatType));
            update(`#price-${sectionId}-${productId}`, Alpine.store('xHelper').formatMoney(currentPrice, moneyFormatType));
          };
          this.setStatusAtc();
          document.dispatchEvent(new CustomEvent(`quantity:changed-${sectionId}`, {
            detail: {
              qty: this.qty
            }
          }));            
        },
        setStatusAtc() {
          const productTemplate = document.getElementById(`x-product-template-${productId}-${sectionId}`);
          const addToCartButton = productTemplate?.querySelector(`#x-atc-button-${sectionId}`);
          if (!addToCartButton) return;
          const blockedByVariant = disableAtc && addToCartButton.dataset.available === undefined;
          if (this.errIncrement || this.errMax || this.errInventory || blockedByVariant) {
            addToCartButton.setAttribute('disabled', true);
            this.atcDisabledBySelector = true;
          } else if (this.atcDisabledBySelector) {
            addToCartButton.removeAttribute('disabled');
            this.atcDisabledBySelector = false;
          }
        }
      }));
    })
  });
}    